module.exports = __webpack_public_path__ + "static/media/balance.c6d9e405.png";